export default __webpack_public_path__ + "static/media/5.63f6cbf1.jpg";